import Vue from "vue";
import App from "./App.vue";
// import router from "./router";
import router from "./router1";
import store from "./store";
import axios from "./http";
import ElementUI from "element-ui";
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/appletDesign.css";
import "./assets/css/base.css";
import "./assets/css/style.css";
import "./assets/font/iconfont.css";
import "./assets/font/iconfont_new2.css";
import '@/assets/common/font/fontFamily.css';
import global from './global/global'
// import 'animate.css'
// 复制 vue-clipboard2
// import VueClipboard from 'vue-clipboard2'
import Clipboard from 'v-clipboard'
// import * as XLSX from 'xlsx'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper)

Vue.use(Clipboard)
Vue.use(ElementUI);
Vue.use(VueQuillEditor);
// Vue.use(XLSX)
Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.ImgHost = 'https://b.yunzhidata.cn/';
Vue.prototype.defultImg = '/static/img/defultbg2@3x.png'; // 默认图
Vue.prototype.userDefult = '/static/img/userDefult.png'; // 默认图
Vue.prototype.meaulist = global

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount("#app");